import React from "react";
import { motion } from "framer-motion";

// components
import FormSection from "../../components/Contact/FormSection";
import SocialMediaSection from "../../components/Contact/SocialMediaSection";
import useTitle from "../../hooks/useTitle";

const contactPageVariants = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 1,
	},
	exit: {
		opacity: 0,
	},
	transition: {
		duration: 1,
	},
};

const hrVariants = {
	initial: {
		width: 0,
	},
	animate: {
		width: "100%",
	},
	view: {
		width: "100%",
	},
	exit: {
		width: 0,
	},
	transition: {
		duration: 3,
	},
};

const ContactPage = () => {
	useTitle("Contact");

	return (
		<motion.div
			variants={contactPageVariants}
			{...contactPageVariants}
			className="mb-5 pb-2 z-10">
			<FormSection />

			<div className="relative flex py-5 items-center w-[90%] mx-auto">
				<div className="flex-grow border-t border-green-800"></div>
				<span className="flex-shrink mx-4">OR</span>
				<div className="flex-grow border-t border-green-800"></div>
			</div>

			<SocialMediaSection />
		</motion.div>
	);
};

export default ContactPage;
